const fatcaExemptions = [
  { key: 0, value: 'No Exemption' },
  { key: 1, value: 'Effectively Connected Income' },
  { key: 2, value: 'Exempt under IRC (other than portfolio interest)' },
  { key: 3, value: 'Income Not From Us Sources' },
  { key: 4, value: 'Exempt under tax treaty' },
  { key: 5, value: 'Portfolio interest exempt under IRC' },
  { key: 6, value: 'QI that assumes primary withholding responsibility' },
  { key: 7, value: 'WFP or WFT' },
  { key: 8, value: 'U.S. branch treated as U.S. Person' },
  { key: 9, value: 'Territory FI treated as U.S. Person' },
  { key: 10, value: 'QI represents that income is exempt' },
  { key: 11, value: 'QSL that assumes primary withholding responsibility' },
  { key: 12, value: 'Payee subjected to chapter 4 withholding' },
  { key: 13, value: 'Grandfathered Payment' },
  { key: 15, value: 'Payee not subject to Ch4 WHD ' },
  { key: 16, value: 'Excluded Non-financial Payment' },
  { key: 17, value: 'Foreign Primary-WHD Entity' },
  { key: 18, value: 'US Payees - of PFFI or RDCFFI' },
  { key: 19, value: 'Exempt from WHD under IGA' },
  { key: 20, value: 'Dormant Account' },
  { key: 21, value: 'Excluded Offshore Payment' },
  { key: 22, value: 'QDD that assumes primary withholding responsibility' },
  { key: 23, value: 'Exempt under section 897(l)' },
];

fatcaExemptions.findByKey = (key) => {
  if (!key || key < 0) {
    return null;
  }

  const code = fatcaExemptions.find(x => x.key === key);
  return code && code.value ? code.value : null;
};

export default fatcaExemptions;
